import { moduleDefaultConfig } from "../../../config/moduleDefaultConfig"
import * as yup from "yup"
let moduleConfig = {}
moduleConfig = {
    ...moduleDefaultConfig
};

moduleConfig.title = 'Poll Stats';
moduleConfig.singleItemTitle = 'Poll Stats';
moduleConfig.url = 'poll-stats';
moduleConfig.moduleType = {
    listing: 'block',
    view: 'block'
};


moduleConfig.bulkActions = [
    // {
    //     displayName: "Disabled Selected",
    //     value: "Disabled"
    // },
    // {
    //     displayName: "Enabled Selected",
    //     value: "Enabled"
    // }
];


export default moduleConfig;